import React from 'react';
import DOMPurify from 'dompurify';
import { Skeleton, Alert } from '@mui/material';
import { useStandardNdaQuery } from '../../shared/hooks/Queries/useStandardNdaQuery';
import { Guid } from '../../shared/models';

interface StandardNdaProps {
	dataRoomGuid: Guid | undefined;
	companyName: string;
}

export const StandardNda: React.FC<StandardNdaProps> = ({ dataRoomGuid, companyName }) => {
	const { data, isLoading, isError } = useStandardNdaQuery(dataRoomGuid, companyName);

	if (isLoading) return <Skeleton height={400} />;
	if (isError) return <Alert severity="error">Unable to load NDA text.</Alert>;
	if (!data) return null;

	return (
		<div
			className="ndaBox"
			dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(data) }}
		/>
	);
};
